import script from "./pwaAntiBlockingPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./pwaAntiBlockingPopup.vue?vue&type=script&setup=true&lang=ts"

import "./pwaAntiBlockingPopup.vue?vue&type=style&index=0&id=a10d7ffa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a10d7ffa"]])

export default __exports__